import { removeSpaces } from '@common/utils/fileNameHelpers';
import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes, HEADINGS_ROW_HEIGHT } from '@common/xlsxExport/xlsxExport.constants';
import { viewTypes, groupTypes, COLUMNS, OPTION_ALL } from './constants';
import getColumnDefs from './getColumnDefs';
import { BOOK_TYPES } from '../shared/constants';

const getFilteredColumnDefs = (
  reportBookType,
  groupType,
  groupItem,
  hasSourceCurrency,
  useHistorical,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus
) =>
  getColumnDefs(reportBookType, groupType, groupItem, {
    hasSourceCurrency,
    useHistorical,
    shouldDisplayZero,
    hideDecimals,
    negativeMinus,
  })
    .filter(({ hide }) => !hide);

export default ({
  period,
  reportData,
  detailRows,
  viewType,
  selectedReportBookTypes,
  groupType,
  groupItem,
  countryTaxTypeDescription,
  hasSourceCurrency,
  reportingCurrencyCode,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  useHistorical,
  environmentSuffix,
  useExpandableDetailsList = false,
}) => {
  const chosenViewType = viewTypes.find(type => type.value === viewType);
  const chosenGroupType = groupTypes.find(type => type.value === groupType);
  const selectedBookTypes = selectedReportBookTypes || Object.keys(reportData || {});

  const bookTypeSheetMeta = {
    [BOOK_TYPES.US_SUMMARY]: { name: 'US Summary', bookType: BOOK_TYPES.US_SUMMARY },
    [BOOK_TYPES.US_FED]: { name: 'US Federal', bookType: BOOK_TYPES.US_FED },
    [BOOK_TYPES.US_STATE]: { name: countryTaxTypeDescription === OPTION_ALL.label ? 'US State' : countryTaxTypeDescription, bookType: BOOK_TYPES.US_STATE },
    [BOOK_TYPES.TED_NON_US_GAAP]: { name: 'GAAP Non-US', bookType: BOOK_TYPES.TED_NON_US_GAAP },
    [BOOK_TYPES.TED_NON_US_STAT]: { name: 'STAT Non-US', bookType: BOOK_TYPES.TED_NON_US_STAT },
  };

  const sheetData = selectedBookTypes.map(bookType => {
    if (useHistorical && bookType === BOOK_TYPES.US_SUMMARY) {
      return null;
    }

    const report = reportData?.[bookType];
    if (!report) {
      return null;
    }

    const meta = bookTypeSheetMeta[bookType];
    if (!meta) {
      return null;
    }

    if (viewType === COLUMNS) {
      return {
        name: meta.name,
        data: report,
        type: SheetExportTypes.REPORT,
        descriptionColumnIndex: useExpandableDetailsList ? 2 : 1,
        options: {
          omitExportIfNull: true,
          numberOfColumnsToStick: 3,
          numberOfAdditionalRowsToStick: 3,
          detailRows: detailRows?.[bookType],
          shouldDisplayZero,
          hideDecimals,
          negativeMinus,
          addTimestamp: true,
          splitDescriptionColumn: true,
          isFunctionalCurrency: hasSourceCurrency,
          groupByTag: useExpandableDetailsList,
        },
      };
    }

    return {
      name: meta.name,
      data: report.rawSource,
      columnDefinitions: getFilteredColumnDefs(
        meta.bookType,
        groupType,
        groupItem,
        hasSourceCurrency,
        useHistorical,
        shouldDisplayZero,
        hideDecimals,
        negativeMinus
      ),
      type: SheetExportTypes.GRID,
      additionalMetadata: [
        { value: report.name, height: HEADINGS_ROW_HEIGHT },
      ],
      options: {
        numberOfColumnsToStick: 1,
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
        addTimestamp: [BOOK_TYPES.US_SUMMARY, BOOK_TYPES.US_FED].includes(bookType),
        headerRowHeight: 60,
      },
    };
  });

  const reportName = `${useHistorical ? 'Historical_' : ''}Tax_Expense`;

  xlsxExport({
    sheetData: sheetData.filter(Boolean),
    metadata: {
      description: `${period.name}, ${chosenGroupType.label}, Currency: ${reportingCurrencyCode}, ${chosenViewType.label}`,
      fileName: removeSpaces(`TLS_${reportName}_${period.name}_${chosenGroupType.label}_${reportingCurrencyCode}${environmentSuffix}`),
    },
  });
};
